import { createSlice } from "@reduxjs/toolkit";
import { getMaterialDetailsAPI } from "../../services/getMaterialDetails";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const getMaterialDetailsSlice = createSlice({
  name: "getMaterialDetails",
  initialState: data,
  reducers: {
    getMaterialDetailsInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
      state.statusCode = undefined;
    },
    getMaterialDetailsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = action?.payload?.message || "";
      state.error = "";
      state.statusCode = undefined;
    },
    getMaterialDetailsInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = "";
      state.error = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    getMaterialDetailsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const getMaterialDetailsHandler =
  (payload, options = {}) =>
  async (dispatch) => {
    const requestOptions = { skipForbiddenRedirect: true, ...options };

    try {
      dispatch(getMaterialDetailsAction.getMaterialDetailsInfo());
      const response = await getMaterialDetailsAPI(payload, requestOptions);
      dispatch(getMaterialDetailsAction.getMaterialDetailsInfoSuccess(response));
    } catch (e) {
      const failurePayload =
        e && typeof e === "object" && "message" in e
          ? e
          : { message: e || "Something went wrong." };
      dispatch(
        getMaterialDetailsAction.getMaterialDetailsInfoFailure(failurePayload),
      );
    }
  };

export default getMaterialDetailsSlice.reducer;
export const getMaterialDetailsAction = getMaterialDetailsSlice.actions;
